import { connect } from "react-redux";

function Analytics() {
    return (
        <div className="main-container">
            Hello Analytics
        </div>
    );
}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    
})(Analytics);
